import type { SentryFlowTier, SentryIncidentPriority } from '../types';

export const FLOW_TIER_PRIORITY: Record<SentryFlowTier, SentryIncidentPriority> =
  {
    p0: 'critical',
    p1: 'high',
  };

export const DEFAULT_INCIDENT_PRIORITY: SentryIncidentPriority = 'medium';

export const LEGACY_PRIORITY: Record<SentryIncidentPriority, string> = {
  critical: 'p0',
  high: 'p1',
  medium: 'p2',
  low: 'p3',
};
